import { ISidebarProps } from '@/types';
import { cn } from '@/lib/utils';
import React from 'react';
import { NavLink, useLocation } from 'react-router';
import { ChevronDown } from 'lucide-react';

export const SideBarItem: React.FC<{
  item: ISidebarProps;
  onClick?: () => void;
  isDropdownOpen?: boolean;
}> = ({ item, onClick, isDropdownOpen }) => {
  const location = useLocation();
  const Icon = item.icon;
  const hasChildren = item.children && item.children.length > 0;

  // For items with children, check if any child is active
  const isPathActive = hasChildren
    ? item.children!.some(child => location.pathname === child.target)
    : location.pathname === item.target;

  // If has children, render a button (not a link) to toggle submenu
  if (hasChildren) {
    return (
      <li className="list-none">
        <button
          type="button"
          onClick={onClick}
          className={cn(
            'group flex w-full items-center justify-between gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-all duration-200',
            isPathActive || isDropdownOpen
              ? 'bg-primary-50 text-primary-700'
              : 'text-coal-600 hover:bg-coal-100 hover:text-coal-800'
          )}
        >
          <div className="flex items-center gap-3">
            <span className={cn(
              'flex h-5 w-5 items-center justify-center transition-colors',
              isPathActive || isDropdownOpen ? 'text-primary' : 'text-coal-400 group-hover:text-coal-600'
            )}>
              {Icon && <Icon />}
            </span>
            <span>{item.title}</span>
          </div>
          <span
            className={cn(
              'transition-transform duration-300 ease-out',
              isDropdownOpen && 'rotate-180'
            )}
          >
            <ChevronDown className="h-4 w-4" />
          </span>
        </button>
      </li>
    );
  }

  return (
    <li className="list-none">
      <NavLink
        className={cn(
          'group flex items-center justify-between gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-all duration-200',
          isPathActive
            ? 'bg-primary-50 text-primary-700'
            : 'text-coal-600 hover:bg-coal-100 hover:text-coal-800'
        )}
        to={item.target}
      >
        <div className="flex items-center gap-3">
          <span className={cn(
            'flex h-5 w-5 items-center justify-center transition-colors',
            isPathActive ? 'text-primary' : 'text-coal-400 group-hover:text-coal-600'
          )}>
            {Icon && <Icon />}
          </span>
          <span>{item.title}</span>
        </div>
      </NavLink>
    </li>
  );
};
